import get from 'lodash/get';

import { PLAN_TIER } from '@wetransfer/transfer/constant/plan-tier';
import { UNLIMITED_TRANSFER_LIMIT } from '@wetransfer/transfer/constant/sizes';
import helper from '@wetransfer/transfer/helper';

export function userNeedsTips(user) {
  const isNotLoggedIn = !user || !user.loggedIn;
  const hasPlusCookie = helper.getWTPlus() === 1;
  const hasNotSentTooManyTransfers = helper.getWTSent() < 5;

  return isNotLoggedIn && hasPlusCookie && hasNotSentTooManyTransfers;
}

export const getPlanTier = (user) => {
  return Boolean(user) && (user.planTier || user.plan_tier);
};

export function userHasPlusTier(user) {
  return getPlanTier(user) === PLAN_TIER.PLUS;
}

export function userHasPro2022Tier(user) {
  return getPlanTier(user) === PLAN_TIER.PRO_2022;
}

export function userHasProOrPlusTier(user) {
  return (
    getPlanTier(user) === PLAN_TIER.PRO_2022 ||
    getPlanTier(user) === PLAN_TIER.PLUS
  );
}

export function userHasPremium2022Tier(user) {
  return getPlanTier(user) === PLAN_TIER.PREMIUM_2022;
}

// Used for checking if the user has any paid tier
export function userHasPaidTier(user) {
  return (
    Boolean(user) &&
    (userHasPlusTier(user) ||
      userHasPro2022Tier(user) ||
      userHasPremium2022Tier(user))
  );
}

export function userHasFreeTier(user) {
  return getPlanTier(user) === PLAN_TIER.FREE;
}

export function isLoggedInFreeUser(user) {
  return Boolean(user) && user.loggedIn && userHasFreeTier(user);
}

export function userHasMaxTier(user) {
  let isMaxTier = false;

  const planTier = getPlanTier(user);

  isMaxTier = planTier === PLAN_TIER.PREMIUM_2022;

  return Boolean(user) && user.loggedIn && isMaxTier;
}

export function isLoggedOutOrFreeUser(user) {
  return !user || !user.loggedIn || userHasFreeTier(user);
}

export function getCurrentTier(user) {
  return (Boolean(user) && user.planTier) || null;
}

export function isLoggedInWithUnlimitedTransfer(user) {
  return (
    Boolean(user) &&
    user.loggedIn &&
    Boolean(user.rules) &&
    user.rules.transferLimit === UNLIMITED_TRANSFER_LIMIT
  );
}

export function getFormalName(givenName, familyName) {
  return typeof familyName === 'string' && familyName !== ''
    ? `${familyName}, ${givenName}`
    : givenName;
}

export function userCanManageSubscription(account) {
  return Boolean(get(account, 'subscription.scopes.web_manageable'));
}

export function userCanHaveSeats(account) {
  return Boolean(get(account, 'subscription.scopes.can_have_seats'));
}

export function userHasCancelledSubscription(account) {
  return Boolean(get(account, 'subscription.cancel_at_period_end'));
}
